import React from 'react';

type Props = {
  theme?: 'light' | 'dark';
};

export default function ZapierAppDirectory({ theme = 'light' }: Props) {
  return (
    <zapier-app-directory
      app="bugherd"
      theme={theme}
      applimit={4}
      zaplimit={6}
      zapstyle="row"
      introcopy="hide"
      style={{
        width: 'calc(100% - 4px)',
        margin: '0 auto'
      }}
    />
  );
}
